import { useEffect } from "react";
import { useTheme } from "styled-components";
import { observer, inject } from "mobx-react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { Text } from "../UI";
import { CircleDiv } from "../components/Common";
import { blue } from "../UI/themes";
const NewApply = ({
  img,
  title,
  selected,
  navigateTo,
  setTitle,
  isAdmin,
  backgroundColor,
  style,
  onItemClicked,
  isMobile,
}) => {
  const navigate = useNavigate();
  let theme = useTheme();
  const { t } = useTranslation("menu");

  if (!!isAdmin) {
    theme = blue;
  }

  const handleMenuItemSelect = (navigateTo, title) => {
    if (onItemClicked) {
      onItemClicked();
    } else {
      setTitle(title);
      navigate(navigateTo);
    }
  };

  useEffect(() => {
    if (!selected) return;
    setTitle(title);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selected]);

  return (
    <div
      style={{
        ...style,
        display: "flex",
        flexDirection: "column",
        cursor: "pointer",
        alignSelf: "center",
      }}
      onClick={() => handleMenuItemSelect(navigateTo, title)}>
      <CircleDiv
        style={{ boxShadow: isMobile ? "0px 2px 4px 0px #00000026" : "unset" }}
        backgroundColor={
          backgroundColor
            ? backgroundColor
            : selected
            ? theme.color.primary
            : theme.color.white
        }>
        <div
          title="menu-item"
          style={{
            mask: `url(${img}) no-repeat center / contain`,
            backgroundColor: "#0a2c4c",
            width: 20,
            height: 20,
          }}></div>
      </CircleDiv>
      {!isMobile && (
        <Text.H6 style={{ textAlign: "center" }}> {t(title)} </Text.H6>
      )}
    </div>
  );
};

export default inject("userStore", "tenantsStore")(observer(NewApply));
